import { createSlice } from "@reduxjs/toolkit";
import { animateCss } from "../../../pages/TosterAlert";

import { organizationZoneRecordAction } from "../../actions/OrganizationRegion/OrganizationZoneAction";
import { fetchAllBranchesAction } from "../../actions/OrganizationRegion/organizationBranchAction";
import {
  allStateAction,
  organizationZoneStateAction,
} from "../../actions/OrganizationRegion/organizationStateAction";

const organizationRegionInitialState = {
  zone: [],
  state: [],
  branch: [],
  settingsAllState: [],
  orgZoneState: [],
  loading: false,
  error: false,
};

const organizationRegionSlice = createSlice({
  name: "organizationRegion",
  initialState: organizationRegionInitialState,
  extraReducers: (builder) => {
    builder

      .addCase(organizationZoneRecordAction.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.zone = payload.data;
      })

      .addCase(fetchAllBranchesAction.fulfilled, (state, { payload }) => {
        // Uncomment if you want to store branch data
        state.loading = false;
        state.branch = payload.data?.branches;
        state.state = payload.data?.states;
        return state;
      })
      .addCase(allStateAction.fulfilled, (state, { payload }) => {
        state.settingsAllState = payload?.data?.[0]?.Children;
        return state;
      })

      .addCase(organizationZoneStateAction.fulfilled, (state, { payload }) => {
        state.orgZoneState = payload?.data;
        return state;
      })

      // Shared loading state
      .addMatcher(
        (action) =>
          [
            organizationZoneRecordAction.pending.type,
            fetchAllBranchesAction.pending.type,
            allStateAction.pending.type,
            organizationZoneStateAction.pending.type,
          ].includes(action.type),
        (state) => {
          state.loading = true;
        }
      )

      .addMatcher(
        (action) =>
          [
            organizationZoneRecordAction.rejected.type,
            fetchAllBranchesAction.rejected.type,
            allStateAction.rejected.type,
            organizationZoneStateAction.rejected.type,
          ].includes(action.type),
        (state) => {
          state.loading = false;
          state.error = true;
        }
      );
  },
});

export default organizationRegionSlice.reducer;
